import React from "react"
import hero from "../../images/1606077576667 1.png"
import styled from "styled-components"

const HeroImage = () => {
  return (
    <StyledWrapper>
      <StyledImage src={hero} alt="hero image" />
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  max-width: 600px;
  height: 100vh;
  
   ${({theme}) => theme.media.tablet} {
    display: none;
  }
  
  ${({theme}) => theme.media.phone} {
    display: none;
  }
`

const StyledImage = styled.img`
  height: 500px;
  width: 500px;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
  
  @media (max-width: 1100px) {
    width: 300px;
    height: 300px;
  }
`

export default HeroImage
